import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postMipInvestorsReleaseSingle } from '@dealstack/frontend/shared/dataExchange/services/mip-manage.service.ts';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2.tsx';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn.ts';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';

export const useReleaseInvestmentWorkflowMutation = (mipId: string) => {
	const queryClient = useQueryClient();
	const tMipManage = useTranslationMipManage();

	return useMutation({
		mutationFn: (investorId: string) => postMipInvestorsReleaseSingle({ mipId, investorId }),
		onSuccess: async () => {
			await queryClient.invalidateQueries({
				queryKey: [
					formatUnicorn(
						API_PATHS.MIP_MIPID_INVESTOR_INVESTMENT_WORKFLOW_MIP_INVESTMENTS_LIST_POST,
						{ mipId }
					),
				],
			});
			showToastV2({
				title: tMipManage('investors.release_success'),
				state: 'success',
			});
		},
		onError: () => {
			showToastV2({
				title: tMipManage('investors.release_error'),
				state: 'error',
			});
		},
	});
};
